import React from 'react';
import { useParams, Link } from 'react-router-dom';

function Article({ articles, darkMode }) {
  const { id } = useParams();
  const article = articles.find(a => a.id === parseInt(id));

  if (!article) {
    return <div className="article-not-found">Article not found</div>;
  }

  const handleShare = async () => {
    const shareData = {
      title: article.title,
      text: `Check out this article: ${article.title}`,
      url: window.location.href
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
        console.log('Shared successfully');
      } catch (err) {
        console.log('Error sharing:', err);
      }
    } else {
      // Fallback for browsers that don't support Web Share API
      try {
        await navigator.clipboard.writeText(window.location.href);
        alert('Link copied to clipboard!');
      } catch (err) {
        console.log('Error copying to clipboard:', err);
      }
    }
  };

  return (
    <div className={`article-container ${darkMode ? 'dark' : ''}`}>
      {/* Parallax Hero Section */}
      <div
        className="article-hero"
        style={{ backgroundImage: `url(${article.image})`, backgroundAttachment: "local" }}
      >
        <div className="hero-overlay">
          <h1 className="hero-title">{article.title}</h1>
        </div>
      </div>

      {/* Article Card */}
      <div className={`article-card ${darkMode ? 'dark-card' : ''}`} style={{padding: "32px"}}>
        <div className="article-header">
          <Link to="/" className="back-link">← Back to Blog</Link>
          <p className="article-date">{article.date}</p>
        </div>

        {/* Article content in a card layout */}
        <div className="article-content">
          <div className="article-meta">
            <p><strong>Author:</strong> {article.Author}</p>
            <p><strong>Tags:</strong> {article.Tags}</p>
          </div>
          <div className="article-body"> <div dangerouslySetInnerHTML={{ __html:article.content }} /></div>
        </div>

        {/* Social sharing or related articles section (Optional) */}
        <div className="article-footer">
          <button className="share-button" onClick={handleShare}>
            <i className="fas fa-share"></i>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Article;